import React, { useEffect, useState } from 'react';
import styles from './TypeWritter.module.css';

interface TypewriterProps {
  texts: string[];           // Frases a serem exibidas
  speed?: number;            // Velocidade da digitação
  pause?: number;            // Tempo de pausa entre frases
  className?: string;        // Classe CSS opcional
}

const Typewriter: React.FC<TypewriterProps> = ({
  texts,
  speed = 100,
  pause = 1500,
  className,
}) => {
  const [currentText, setCurrentText] = useState('');
  const [textIndex, setTextIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    let typingTimeout: NodeJS.Timeout;

    const fullText = texts[textIndex];
    const nextChar = isDeleting
      ? fullText.slice(0, currentText.length - 1)
      : fullText.slice(0, currentText.length + 1);

    const delay = isDeleting ? speed / 2 : speed;

    if (!isDeleting && currentText === fullText) {
      typingTimeout = setTimeout(() => setIsDeleting(true), pause);
    } else if (isDeleting && currentText === '') {
      setIsDeleting(false);
      setTextIndex((prev) => (prev + 1) % texts.length);
    } else {
      typingTimeout = setTimeout(() => setCurrentText(nextChar), delay);
    }

    return () => clearTimeout(typingTimeout);
  }, [currentText, isDeleting, textIndex, texts, speed, pause]);

  return <span className={className}>{currentText}<span className={styles.cursor}>|</span></span>;
};

export default Typewriter;
